module.exports = __webpack_public_path__ + "assets/img_alcohol_free.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_alcohol_free.png
 ** module id = 116
 ** module chunks = 1
 **/